import { render } from "./product-single-feature.vue?vue&type=template&id=eee36b8c&scoped=true"
import script from "./product-single-feature.vue?vue&type=script&lang=js"
export * from "./product-single-feature.vue?vue&type=script&lang=js"

import "./product-single-feature.vue?vue&type=style&index=0&id=eee36b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eee36b8c"]])

export default __exports__